// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_ECc","cls2":"Header-cls2__GC Header-cls1_ECc"};